<template>
  <v-navigation-drawer
    v-model="ui.leftDrawer"
    permanent
    order="0"
    style="transition-property: all;"
    class="grey lighten-4"
    floating
    color="grey-lighten-4"
    width="300"
  >
    <v-toolbar
      color="primary"
      :flat="!ui.toolbarElevation"
      style="opacity: 0.9;"
    >
      <v-app-bar-nav-icon
        v-show="ui.leftDrawer"
        flat
        class="mr-3"
        @click="ui.leftDrawer = !ui.leftDrawer"
      />
      <h3 style="font-weight: normal">
        OCH POWER {{ $t('ServiceName') }}
      </h3>
    </v-toolbar>

    <v-list density="compact">
      <!-- main features -->
      <v-list-item
        v-for="item in items.filter((item) => item.group)"
        :key="item.title"
        :title="$t(item.title)"
        class="text-accent"
        @click="$router.push({ name: item.name, params: item.params })"
      >
        <template #prepend>
          <v-icon
            :icon="item.icon"
            color="accent"
            style="opacity: 100"
          />
        </template>
      </v-list-item>

      <v-divider />
      <v-list-subheader class="text-grey align-center my-2">
        {{ $t('Service.Service') }}
      </v-list-subheader>

      <!-- services -->
      <v-list-item
        v-for="item in items.filter((item) => !item.group)"
        :key="item.title"
        class="text-accent"
        @click="$router.push({ name: item.name, params: item.params })"
      >
        <template #prepend>
          <img
            :src="item.iconFile"
            height="30"
            alt="icon"
            class="mr-4"
          >
        </template>
        <v-list-item-title>
          {{ $t(item.title) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ServiceIconMixin from '@/components/parts/mixins/ServiceIconMixin'

  export default {
    mixins: [ServiceIconMixin],
    data: () => ({
      items: [],
      isAdmin: false
    }),
    computed: {
      ...mapGetters([
        'ui',
        'login'
      ]),
      accountListTitle () {
        return this.isAdmin
          ? 'Menu.ManageAccounts'
          : 'Menu.AccountList'
      }
    },
    watch: {
      login: {
        handler () {
          if (!this.isAdmin && this.login.profile.is_admin) {
            this.extendMenu()
          }
          this.isAdmin = this.login.profile.is_admin
        },
        deep: true
      }
    },
    created () {
      this.$http.get('available-services/', { params: { limit: 1000 } }).then(
        (res) => {
          this.applyMenu()
          const filteredData = this.$filters.removeUnusedServices(res.data.results)
          filteredData.forEach((v) => {
            this.items.push({
              title: 'Service.Brand.' + v.id,
              name: v.id,
              admin: false,
              iconFile: this.image(v.icon_file)
            })
          })
        })
    },
    methods: {
      applyMenu () {
        this.items = [
          {
            title: 'Menu.Home',
            name: 'HomePage',
            icon: 'mdi-home',
            params: {},
            admin: false,
            group: true
          },
          // {title: 'Menu.PersonalSettings', name: 'PersonalSettings', icon: 'person', params: {}, admin: false},
          {
            title: this.accountListTitle,
            name: 'ManageAccounts',
            icon: 'mdi-account-multiple',
            params: {},
            admin: false,
            group: true
          }
          // {
          //   title: 'Menu.ManagePayments',
          //   name: 'ManagePayments',
          //   icon: 'payment',
          //   params: {},
          //   admin: true
          // },
          // {group: true, title: 'Service.Service', admin: false}
        ]

        // the following features are only seen by admin
        if (this.isAdmin) {
          this.extendMenu()
        }
      },
      extendMenu () {
        this.items.push(...[
        {
          title: 'Menu.DeletedManageAccounts',
          name: 'DeletedManageAccounts',
          icon: 'mdi-delete',
          params: {},
          admin: true,
          group: true
        },
        {
          title: 'Menu.CustomerSettings',
          name: 'CustomerSettings',
          icon: 'mdi-domain',
          params: {},
          admin: true,
          group: true
        }])
        }
    }
  }
</script>
